import React, { useState } from "react";
import { Box, Typography, Button, IconButton, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { logout, getValidToken } from "../lib/auth";
import { jwtDecode } from "jwt-decode";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let username = null;
  const token = getValidToken(); // 期限切れなら自動削除してnullを返す
  if (token) {
    try {
      const decoded = jwtDecode(token);
      const email = decoded.email || (decoded.sub && decoded.sub.email);
      if (email) username = email.split("@")[0];
    } catch (e) {}
  }

  const handleLogout = () => { logout(); navigate("/login"); };

  const isActive = (path) => location.pathname === path;

  return (
    <Box
      component="header"
      sx={{
        backgroundColor: "#edeae4",
        borderBottom: "1px solid #ccc8c2",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      {/* Top utility bar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          px: { xs: 2, md: 4 },
          py: 0.5,
          borderBottom: "1px solid #ccc8c2",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "#78716c", fontSize: "0.72rem", cursor: "pointer" }}>
          <SearchIcon sx={{ fontSize: 13 }} />
          <Typography sx={{ fontSize: "0.72rem", fontFamily: "inherit" }}>CMD + K</Typography>
        </Box>

        {!username ? (
          <>
            <Button
              component={Link}
              to="/login"
              size="small"
              sx={{ fontSize: "0.72rem", color: "#78716c", p: 0, minWidth: 0, fontFamily: "inherit" }}
            >
              SIGN IN
            </Button>
            <Button
              component={Link}
              to="/signup"
              size="small"
              sx={{ fontSize: "0.72rem", color: "#78716c", p: 0, minWidth: 0, fontFamily: "inherit" }}
            >
              SIGN UP
            </Button>
          </>
        ) : (
          <>
            <Tooltip title="お気に入り">
              <IconButton component={Link} to="/favorites" size="small" sx={{ p: 0.25, color: "#78716c" }}>
                <FavoriteIcon sx={{ fontSize: 14 }} />
              </IconButton>
            </Tooltip>
            <Button
              size="small"
              onClick={handleLogout}
              sx={{ fontSize: "0.72rem", color: "#78716c", p: 0, minWidth: 0, fontFamily: "inherit" }}
            >
              {username.toUpperCase()} ×
            </Button>
          </>
        )}
      </Box>

      {/* Main header row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: { xs: 2, md: 4 },
          py: { xs: 1.5, md: 2 },
        }}
      >
        {/* Logo */}
        <Typography
          component={Link}
          to="/"
          sx={{
            textDecoration: "none",
            fontFamily: '"Courier New", Courier, monospace',
            fontWeight: 900,
            fontSize: { xs: "1.6rem", md: "2rem" },
            letterSpacing: "0.12em",
            color: "#1c1916",
            display: "flex",
            alignItems: "baseline",
            gap: 1,
            lineHeight: 1,
            userSelect: "none",
          }}
        >
          <Box
            component="span"
            sx={{
              fontWeight: 900,
              letterSpacing: "0.08em",
              textShadow: "2px 2px 0 #ccc8c2",
            }}
          >
            GL AI News
          </Box>
        </Typography>

        {/* Nav tabs */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            component={Link}
            to="/"
            size="small"
            sx={{
              fontSize: "0.75rem",
              fontFamily: "inherit",
              fontWeight: 700,
              color: isActive("/") ? "#1c1916" : "#78716c",
              backgroundColor: isActive("/") ? "#ddd9d2" : "transparent",
              border: "1px solid",
              borderColor: isActive("/") ? "#ccc8c2" : "transparent",
              px: 1.5,
              py: 0.4,
              borderRadius: 1,
              "&:hover": { backgroundColor: "#ddd9d2", borderColor: "#ccc8c2" },
            }}
          >
            STORIES
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
